import clients from 'redux/clients'

export const searchCards = async (cpf, token) => {
  clients.mileageApi.client.defaults.headers.common['Authorization'] = token
  // clients.mileageApi.client.defaults.baseURL = 'https://mileage-api.getsandbox.com/'
  let retorno = await clients.mileageApi.client.get(`mileage-api/v1/card/SearchCards?cpf=${cpf}`)
  return retorno.status === 200 ? retorno.data : 'Não há cartão requisitado para esse cpf'
}

export const searchTaxes = async (token) => {
  clients.mileageApi.client.defaults.headers.common['Authorization'] = token
  // clients.mileageApi.client.defaults.baseURL = 'https://mileage-api.getsandbox.com/'
  let retorno = await clients.mileageApi.client.get(`mileage-api/v1/tax/calculated-values`)
  return retorno.status === 200 ? retorno.data : 'Não há taxas configuradas'
}

export const pointsToCash = async (points, token) => {
  clients.mileageApi.client.defaults.headers.common['Authorization'] = token
  let retorno = await clients.mileageApi.client.get(`mileage-api/v1/calculators/pointsToMiles/${points}`)
  return retorno.status === 200 ? retorno.data : 'Não foi possivel converter os pontos.'
}

export const redemptionCard = async (body, token) => {
  clients.mileageApi.client.defaults.headers.common['Authorization'] = token
  let retorno = await clients.mileageApi.client.post('mileage-api/v1/orders/redemption', body)
  return retorno.status === 200 ? retorno.data : null
}

export default {
  searchCards,
  searchTaxes,
  pointsToCash,
  redemptionCard
}



// WEBPACK FOOTER //
// ./src/features/LikePlusCustom/LikePlusClient.js